/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

type QueryPreviewCellArgs = {
  value: string | Record<string, any>;
};

export default class QueryPreviewCell extends Component<QueryPreviewCellArgs> {
  get valueIsObject() {
    return typeof this.args.value === 'object';
  }
  get displayValue() {
    return this.valueIsObject ? JSON.stringify(this.args.value) : this.args.value;
  }
}
